import { createContext, useEffect, useState, type ReactNode } from "react";

export type AdminContextType = {
  isAdmin: boolean;
  checkIfAdminPassword: (password: string) => boolean;
  requireAdmin: (callback: () => void) => void;
  clearAdminStatus: () => void;
};

export const AdminContext = createContext<AdminContextType | undefined>(
  undefined
);

export function AdminProvider({ children }: { children: ReactNode }) {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [showAdminModal, setShowAdminModal] = useState<boolean>(false);
  const [pendingCallback, setPendingCallback] = useState<(() => void) | null>(
    null
  );
  const [password, setPassword] = useState<string>("");

  const clearAdminStatus = () => {
    localStorage.removeItem("isAdmin");
    setIsAdmin(false);
  };

  const checkIfAdminPassword = (password: string): boolean => {
    if (password.toLowerCase() === "inovacode@2025") {
      localStorage.setItem("isAdmin", "true");
      setIsAdmin(true);
      return true;
    }
    return false;
  };

  const requireAdmin = (callback: () => void) => {
    if (isAdmin) {
      callback();
    } else {
      setPendingCallback(() => callback);
      setShowAdminModal(true);
    }
  };

  const handleSubmitPassword = () => {
    if (checkIfAdminPassword(password)) {
      setShowAdminModal(false);
      setPassword("");
      if (pendingCallback) {
        pendingCallback();
        setPendingCallback(null);
      }
    } else {
      alert("Senha incorreta!");
    }
  };

  const handleCloseModal = () => {
    setShowAdminModal(false);
    setPassword("");
    setPendingCallback(null);
  };

  useEffect(() => {
    const isAdminLocal = localStorage.getItem("isAdmin");
    setIsAdmin(isAdminLocal === "true");
  }, []);

  return (
    <AdminContext.Provider
      value={{ isAdmin, checkIfAdminPassword, requireAdmin, clearAdminStatus }}
    >
      {children}

      {/* Modal de Autenticação Admin */}
      {showAdminModal && !isAdmin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4">Acesso Administrativo</h2>
            <p className="text-gray-600 mb-4">
              Digite a senha de administrador para continuar:
            </p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmitPassword()}
              className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Senha de administrador"
              autoFocus
            />
            <div className="flex gap-2 justify-end">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                Cancelar
              </button>
              <button
                onClick={handleSubmitPassword}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminContext.Provider>
  );
}
